import styled from 'styled-components';

const SubHeading = styled.h2`
    color: ${props=> props.theme.lightBlue};
    background-color: rgba(0, 0, 0, 0.4);
    text-align: center;
    font-size: 3rem;
    margin: 7rem 2rem;
`;

export default SubHeading;